// S2 No access (7.1): a guest account in neither of the tool's groups, Editors and Admins (member accounts
// need no group, CT-002; poc CT-008), or the sign-in couldn't check the account with Microsoft (check_failed).
import { createFileRoute } from '@tanstack/react-router';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { signOut } from '@/lib/session';

interface NoAccessSearch {
  reason?: string;
}

export const Route = createFileRoute('/no-access')({
  validateSearch: (search: Record<string, unknown>): NoAccessSearch =>
    typeof search.reason === 'string' ? { reason: search.reason } : {},
  component: NoAccess,
});

function NoAccess() {
  const { reason } = Route.useSearch();
  const checkFailed = reason === 'check_failed';
  return (
    <Card className="mx-auto max-w-md">
      <CardContent className="flex flex-col gap-4 p-6">
        <Lock className="size-8 text-muted" aria-hidden="true" />
        <h1 className="text-2xl font-semibold">{checkFailed ? 'We couldn’t check your access' : 'No access'}</h1>
        <p className="text-muted">
          {checkFailed
            ? 'We couldn’t check your groups with Microsoft just now. Wait a minute and sign in again.'
            : 'Guest accounts can use this tool only through one of its groups. Ask a Platform admin to add you to one.'}
        </p>
        <div className="flex flex-wrap gap-2">
          <Button asChild>
            <a href="/auth/sign-in">Sign in again</a>
          </Button>
          <Button variant="secondary" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
